import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate, getActiveLanguage } from '@haldor/ui';
import sniffer from 'sniffer';
import { getUser, onMsalTokenError } from 'lib/msal';
import { withRouter } from 'react-router-dom';
import * as microsoftTeams from "@microsoft/teams-js";
import schoolHandling from 'helpers/schoolHandling';
import roleHandling from 'helpers/roleHandling';
import { trackNoGroups } from 'helpers/insights';
import { ROLE_TEACHER, ROLE_STUDENT, ROLE_MENTOR } from 'constants/roles';
import { postData } from 'actions';
import { setUser, getMe } from 'actions/user';
import { getEducationGroups, getSectionByGraphId, getSection } from 'actions/sections';
import { getTenant, setActiveTeamsTab, verifyUserScopes } from 'actions/user';
import { getTypes } from 'actions/status';
import { markNotificationAsRead } from 'actions/notifications';
import { getTeamsTab } from '../constants/teamsTabs';
import { getServices, isConsentPresent, createTenant, createTenantServices, getAdminInvitations, getTenantProducts, updateTenant, updateTenantProducts, setSelectedServices } from 'actions/services';
import { getSchoolServices } from 'actions/schools';
import Header from 'teams/components/Header';
import DeviceHeader from 'components/HeaderV2/Device';
import Error from 'components/Presentation/Error/Error';
import InteractionRequired from 'containers/Errors/InteractionRequired';
import RequiredDataError from 'containers/Errors/RequiredDataError';
import { Spinner } from 'UI';
import 'assets/css/main.scss';
import Modal from 'containers/Modals/Modal';
import ConsentButton from './components/Header/ConsentButton';
import ZendeskWidget from 'lib/zendeskWidget';

var App = /*#__PURE__*/function (_Component) {
  _inherits(App, _Component);

  var _super = _createSuper(App);

  function App(props) {
    var _this;

    _classCallCheck(this, App);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "isDesktop", function () {
      if (sniffer.isTablet) {
        return true;
      }

      if (sniffer.isDesktop) {
        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "getParameterByName", function (name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    });

    _defineProperty(_assertThisInitialized(_this), "createTenant", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
        var userPrincipalName, tenantDomain, tenant;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userPrincipalName = context.userPrincipalName;
                tenantDomain = null;

                if (userPrincipalName != null && userPrincipalName.indexOf("@") > -1) {
                  tenantDomain = userPrincipalName.substring(userPrincipalName.indexOf("@") + 1).toLowerCase();
                }

                if (tenantDomain == null && context.user.loginHint != null && context.user.loginHint.indexOf("@") > -1) {
                  tenantDomain = context.user.loginHint.substring(context.user.loginHint.indexOf("@") + 1).toLowerCase();
                }

                tenant = {
                  title: "",
                  tenantId: context.user.tenant.id,
                  tenantDomain: tenantDomain,
                  tenantSPOUrl: "https://" + context.sharePointSite.teamSiteDomain
                };
                _context.next = 7;
                return _this.props.createTenant(tenant);

              case 7:
                return _context.abrupt("return");

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "createTenantServices", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var tenantServices, selectedProducts, productPlanning;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.props.getTenantProducts();

            case 2:
              _context2.next = 4;
              return _this.props.getServices();

            case 4:
              tenantServices = [];
              selectedProducts = [];
              console.log("available products", _this.props.products);
              productPlanning = _this.props.products.find(function (product) {
                return product.name === "Haldor Planning";
              });
              selectedProducts.push(productPlanning);
              productPlanning.services.forEach(function (service) {
                if (!tenantServices.find(function (service) {
                  return service.ServiceId == service.id;
                })) {
                  tenantServices.push({
                    ServiceId: service.id
                  });
                }
              });
              _context2.next = 12;
              return _this.props.updateTenantProducts(selectedProducts);

            case 12:
              _context2.next = 14;
              return _this.props.createTenantServices(tenantServices);

            case 14:
              console.log("SelectedProduct", productPlanning);
              console.log("TenantServices", tenantServices);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "initializeBasicCheck", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var context, tab, defaultSchool, group;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _this.getContext();

            case 3:
              context = _context3.sent;

              _this.setState({
                context: context
              });

              console.log(context);
              tab = 'HALDOR_EDUCATION_TAB';

              _this.props.setActiveTeamsTab(tab);

              if (!context.page.subPageId) {
                _context3.next = 11;
                break;
              }

              _context3.next = 11;
              return _this.handleSubEntityId(context.page.subPageId);

            case 11:
              _context3.next = 13;
              return _this.props.getTenant();

            case 13:
              if (!(_this.props.tenant == null)) {
                _context3.next = 26;
                break;
              }

              console.log("NO TENANT");
              _context3.next = 17;
              return _this.createTenant(context);

            case 17:
              _context3.next = 19;
              return _this.props.getTenant();

            case 19:
              _context3.next = 21;
              return _this.props.getMe();

            case 21:
              _context3.next = 23;
              return _this.createTenantServices();

            case 23:
              _context3.next = 25;
              return _this.props.getTenant();

            case 25:
              console.log(_this.props.tenant);

            case 26:
              if (!(_this.props.currentUser == null)) {
                _context3.next = 29;
                break;
              }

              _context3.next = 29;
              return _this.props.getMe();

            case 29:
              console.log("tenant", _this.props.tenant);
              /* Get Section */

              _context3.next = 32;
              return _this.props.getSectionByGraphId(context.team.groupId);

            case 32:
              console.log("Section", _this.props.group);

              if (!(_this.props.group == null)) {
                _context3.next = 49;
                break;
              }

              console.log("No Group found");
              defaultSchool = _this.props.currentUser.schools.find(function (school) {
                return school.defaultSchool === true;
              });

              if (!(defaultSchool == null)) {
                _context3.next = 39;
                break;
              }

              _this.setState({
                error: 'No school was found'
              });

              return _context3.abrupt("return");

            case 39:
              console.log("Default school was found", defaultSchool);
              group = {
                title: context.team.displayName,
                graphId: context.team.groupId,
                classroomUrl: context.sharePointSite.url,
                teamsUrl: 'https://teams.microsoft.com/l/team/' + context.channel.id + '/conversations?tenantId=' + context.user.tenant.id,
                schoolId: defaultSchool.id,
                type: 'EDUCATION_GROUP'
              };
              _context3.next = 43;
              return _this.props.postData(group, 'sections');

            case 43:
              _context3.next = 45;
              return _this.props.getSectionByGraphId(context.team.groupId);

            case 45:
              console.log("Section was found after creation", _this.props.group);

              if (!(_this.props.group == null)) {
                _context3.next = 49;
                break;
              }

              _this.setState({
                error: 'Something went wrong while creating sections'
              });

              return _context3.abrupt("return");

            case 49:
              _context3.next = 51;
              return _this.handleGroupData(_this.props.currentUser, _this.props.group);

            case 51:
              console.log("Handled group data");

              if (_this.props.activeSchool) {
                _context3.next = 56;
                break;
              }

              console.log("No active school was set");

              _this.setState({
                error: 'No Active School available'
              });

              return _context3.abrupt("return");

            case 56:
              _context3.next = 58;
              return _this.props.getSchoolServices(_this.props.activeSchool);

            case 58:
              _context3.next = 60;
              return _this.props.getEducationGroups();

            case 60:
              console.log("groups found", _this.props.groups);

              if (!(!_this.props.groups || !_this.props.groups.length)) {
                _context3.next = 65;
                break;
              }

              console.log("No groups were returned");

              _this.setState({
                error: 'No groups were returned'
              });

              return _context3.abrupt("return");

            case 65:
              _this.props.getTypes(getActiveLanguage());

              console.log("set language");
              console.log("all checks was successful");

              _this.setState({
                loading: false
              });

              _context3.next = 74;
              break;

            case 71:
              _context3.prev = 71;
              _context3.t0 = _context3["catch"](0);

              _this.setState({
                loading: false,
                error: 'Something went wrong, try again'
              });

            case 74:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 71]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "getContext", function () {
      return new Promise(function (resolve, reject) {
        microsoftTeams.app.getContext().then(function (context) {
          if (context) {
            resolve(context);
          } else {
            reject(new Error("Failed to get context"));
          }
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubEntityId", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(subEntityId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this.getParameterByName('notificationId', subEntityId)) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return _this.props.markNotificationAsRead(_this.getParameterByName('notificationId', subEntityId));

              case 3:
                _this.props.history.push(subEntityId);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleGroupData", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(currentUser, group) {
        var teacherRole, role;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                teacherRole = false;
                schoolHandling.setSchoolOnUser(currentUser, group.schoolID);

                if (currentUser.schools && currentUser.schools.length) {
                  teacherRole = _this.checkTeacherRole(currentUser, group.schoolID);
                  role = teacherRole ? ROLE_TEACHER : ROLE_STUDENT;
                  schoolHandling.fetchSchool(_this.props.activeSchool, currentUser);
                  roleHandling.fetchRole(_this.props.activeRole, currentUser, role);
                }

                if (!group.id) {
                  _context5.next = 6;
                  break;
                }

                _context5.next = 6;
                return _this.props.getSection(group.id);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x3, _x4) {
        return _ref5.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "checkTeacherRole", function (currentUser, schoolID) {
      var _iterator = _createForOfIteratorHelper(currentUser.schools),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var school = _step.value;

          if (school.id === schoolID) {
            if (school.userRoles.some(function (us_role) {
              return us_role.toUpperCase() === ROLE_TEACHER;
            })) {
              return true;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "delay", function (duration) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, duration);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleConsentCallBack", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(response) {
        var tried, tryAmount, consentAvailable;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log("TEAMS Consent Callback", response);

                _this.setState({
                  showConsentRequest: false,
                  loading: true
                });

                tried = 0;
                tryAmount = 4;
                _context6.next = 6;
                return _this.delay(1000);

              case 6:
                _context6.next = 8;
                return _this.checkIfNessacarryConsentIsTaken();

              case 8:
                consentAvailable = _context6.sent;

              case 9:
                if (!(tried < tryAmount)) {
                  _context6.next = 25;
                  break;
                }

                console.log("consentAvailable:", consentAvailable);

                if (consentAvailable) {
                  _context6.next = 18;
                  break;
                }

                console.log("Consent not available, trying again" + tried);
                tried = tried + 1;
                _context6.next = 16;
                return _this.delay(3000);

              case 16:
                _context6.next = 20;
                break;

              case 18:
                console.log("Consent available, getting data");
                return _context6.abrupt("break", 25);

              case 20:
                _context6.next = 22;
                return _this.checkIfNessacarryConsentIsTaken();

              case 22:
                consentAvailable = _context6.sent;
                _context6.next = 9;
                break;

              case 25:
                console.log("loop stopped, wait 3s to make sure consent is activated");
                _context6.next = 28;
                return _this.delay(2000);

              case 28:
                if (consentAvailable) {
                  _context6.next = 32;
                  break;
                }

                _this.setState({
                  showConsentRequest: true,
                  loading: false
                });

                _context6.next = 34;
                break;

              case 32:
                _context6.next = 34;
                return _this.initializeBasicCheck();

              case 34:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x5) {
        return _ref6.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "checkIfNessacarryConsentIsTaken", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var context, scopeId;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this.getContext();

            case 2:
              context = _context7.sent;
              scopeId = "User.Read";
              _context7.next = 6;
              return _this.props.verifyUserScopes(context.user.id, scopeId);

            case 6:
              return _context7.abrupt("return", _this.props.currentUserScopesVerification.some(function (ss) {
                return ss.scope.toUpperCase() === scopeId.toUpperCase() && ss.consented;
              }));

            case 7:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    })));

    _this.state = {
      background: '#f3f2f1',
      loading: true,
      groupForm: false,
      error: null,
      showSession: false,
      showConsentRequest: false,
      context: null
    };
    return _this;
  }

  _createClass(App, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var consentAvailable;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.checkIfNessacarryConsentIsTaken();

              case 2:
                consentAvailable = _context8.sent;
                console.log("Consent", consentAvailable);

                if (consentAvailable) {
                  _context8.next = 8;
                  break;
                }

                this.setState({
                  showConsentRequest: true,
                  loading: false
                });
                _context8.next = 10;
                break;

              case 8:
                _context8.next = 10;
                return this.initializeBasicCheck();

              case 10:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      if (this.state.showConsentRequest) {
        return /*#__PURE__*/React.createElement(Modal, {
          isOpen: true,
          type: "small news",
          overridePrompt: true
        }, /*#__PURE__*/React.createElement("div", {
          className: "container",
          style: {
            margin: '1rem 0rem'
          }
        }, /*#__PURE__*/React.createElement("h4", null, this.props.translate('Just one last thing...')), /*#__PURE__*/React.createElement("p", {
          style: {
            marginBottom: '1rem'
          }
        }, this.props.translate('Before you can start using Haldor Planning, you need to give Haldor your consent to collect and process your personal data. Haldor is a Microsoft partner that complies with GDPR legislation and handles your data based on international information and security standards. Haldor only uses data when necessary.')), /*#__PURE__*/React.createElement(ConsentButton, {
          title: "Give consent",
          scopes: "User.Read;Files.ReadWrite.All",
          onResponse: this.handleConsentCallBack
        })));
      }

      if (this.state.error != null) {
        var _this$state$error, _this$state$error$dat, _this$state$error2, _this$state$error2$da;

        if (((_this$state$error = this.state.error) === null || _this$state$error === void 0 ? void 0 : (_this$state$error$dat = _this$state$error.data) === null || _this$state$error$dat === void 0 ? void 0 : _this$state$error$dat.errorCode) == 'invalid_grant' || ((_this$state$error2 = this.state.error) === null || _this$state$error2 === void 0 ? void 0 : (_this$state$error2$da = _this$state$error2.data) === null || _this$state$error2$da === void 0 ? void 0 : _this$state$error2$da.errorCode) == 'interaction_required') {
          var _this$state$error3;

          return /*#__PURE__*/React.createElement(InteractionRequired, {
            error: (_this$state$error3 = this.state.error) === null || _this$state$error3 === void 0 ? void 0 : _this$state$error3.data
          });
        } else {
          return /*#__PURE__*/React.createElement(RequiredDataError, {
            errorMessage: this.state.error
          });
        }
      }

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: 'center'
          }
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }), this.state.showSession ? /*#__PURE__*/React.createElement("span", {
          style: {
            color: 'var(--color--meta)'
          }
        }, "Session ID: ", localStorage.getItem('hsid')) : null);
      }

      if (this.props.currentUser != null) {
        var currentUser = this.props.currentUser;

        if (currentUser.schools == null || currentUser.schools.length < 1 || currentUser.roles == null || currentUser.roles.length < 1) {
          return /*#__PURE__*/React.createElement("div", {
            style: {
              backgroundColor: this.state.background
            }
          }, /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement("div", {
            className: "login-content"
          }, /*#__PURE__*/React.createElement("h1", null, this.props.translate('something-went-wrong')), /*#__PURE__*/React.createElement("p", {
            className: "login-content__subtitle"
          }, this.props.translate('error-no-schools-or-roles'))));
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "tab-content",
          style: {
            backgroundColor: this.state.background
          }
        }, !this.isDesktop() ? /*#__PURE__*/React.createElement(DeviceHeader, null) : /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement(Error, null), /*#__PURE__*/React.createElement("div", {
          className: "app-comp-content content"
        }, this.props.children));
      } else {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }
    }
  }]);

  return App;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    languages: state.Languages.languages,
    currentUser: state.user.currentUser,
    tenant: state.user.tenant,
    currentUserScopesVerification: state.user.myScopesVerification,
    activeSchool: state.user.activeSchool,
    activeRole: state.user.activeRole,
    products: state.Services.availableProducts,
    groups: state.sections.educationGroups,
    group: state.sections.graphSection
  };
}

export default connect(mapStateToProps, {
  setUser: setUser,
  getEducationGroups: getEducationGroups,
  getTenant: getTenant,
  getSchoolServices: getSchoolServices,
  getTenantProducts: getTenantProducts,
  getMe: getMe,
  setActiveTeamsTab: setActiveTeamsTab,
  updateTenantProducts: updateTenantProducts,
  getSectionByGraphId: getSectionByGraphId,
  getServices: getServices,
  getSection: getSection,
  getTypes: getTypes,
  postData: postData,
  createTenant: createTenant,
  createTenantServices: createTenantServices,
  markNotificationAsRead: markNotificationAsRead,
  verifyUserScopes: verifyUserScopes
})(App);